import { createApi } from '@reduxjs/toolkit/query/react'
import { axiosBaseQuery } from './axiosBaseQuery'

/** How long a list, page or search stays fresh, from its request, and how long an unwatched one is kept: five minutes. */
const SERVER_LIST_LIFETIME_SECONDS = 300

/**
 * The RTK Query API for server lists (see ARCHITECTURE.md "Server lists: RTK Query"). One `createApi`; each domain
 * adds its endpoints with `injectEndpoints` in its own file (`teamApi.ts`).
 *
 * The cache rule every list follows: an answer is used for five minutes from its request and refetched on the next mount
 * or argument change after that; never on focus or reconnect. A page reload is a new store. Changes made in this tab
 * invalidate the list once the save succeeds; changes made elsewhere arrive on the socket and patch cached rows
 * (`updateQueryData`, which keeps the request time). Logout resets everything (`resetApiOnLogout`).
 */
export const baseApi = createApi({
    reducerPath: 'api',
    baseQuery: axiosBaseQuery(),
    tagTypes: ['TeamMembers', 'TeamDrivers', 'TeamDriverFull', 'TeamPeople'],
    keepUnusedDataFor: SERVER_LIST_LIFETIME_SECONDS,
    refetchOnMountOrArgChange: SERVER_LIST_LIFETIME_SECONDS,
    refetchOnFocus: false,
    refetchOnReconnect: false,
    endpoints: () => ({}),
})
